import getUrl from 'airship/modules/get-url'
import createRequest from 'airship/modules/request2/ua-request'

import {AnalyticsDisabledError} from './errors'
import {BackendProps} from './types'

export interface EventPropertiesApiClient {
  fetchAppEventProperties(pathname: string): Promise<BackendProps | null>

  fetchNonAppEventProperties(pathname: string): Promise<BackendProps | null>
}

export class ApiClient implements EventPropertiesApiClient {
  appKey: string | undefined

  public constructor(appKey: string | undefined) {
    this.appKey = appKey
  }

  public fetchAppEventProperties(
    pathname: string
  ): Promise<BackendProps | null> {
    if (!this.appKey) {
      return Promise.resolve(null)
    }

    return this.fetchEventProperties(
      getUrl('analytics:analytics_api_app_event_properties', this.appKey || ''),
      pathname
    )
  }

  public fetchNonAppEventProperties(
    pathname: string
  ): Promise<BackendProps | null> {
    return this.fetchEventProperties(
      getUrl('analytics:analytics_api_user_event_properties'),
      pathname
    )
  }

  async fetchEventProperties(
    apiEndpoint: string,
    pathname: string
  ): Promise<BackendProps | null> {
    const query = {path: pathname}
    const req = createRequest({path: apiEndpoint})
    const res = await req.get({query})
    req.end()

    if (res.statusCode === 451) {
      throw new AnalyticsDisabledError()
    } else if (res.statusCode !== 200) {
      throw new Error(`Event properties API returned ${res.statusCode}`)
    }

    return res.body
  }
}
